import { render, staticRenderFns } from "./base-summary-card.vue?vue&type=template&id=6a48faa2&scoped=true&"
import script from "./base-summary-card.vue?vue&type=script&lang=js&"
export * from "./base-summary-card.vue?vue&type=script&lang=js&"
import style0 from "./base-summary-card.vue?vue&type=style&index=0&id=6a48faa2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a48faa2",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a48faa2')) {
      api.createRecord('6a48faa2', component.options)
    } else {
      api.reload('6a48faa2', component.options)
    }
    module.hot.accept("./base-summary-card.vue?vue&type=template&id=6a48faa2&scoped=true&", function () {
      api.rerender('6a48faa2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/crm/components/base-summay-card/base-summary-card.vue"
export default component.exports